'use strict';

var _classCallCheck = require("/Users/yosuke.aramaki/Desktop/Gaiax/oss-gaiax-blockchain/check-in/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/yosuke.aramaki/Desktop/Gaiax/oss-gaiax-blockchain/check-in/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var multihashing = require('multihashing-async');

module.exports = function (keysProtobuf, randomBytes, crypto) {
  crypto = crypto || require('./crypto')(randomBytes);

  var Secp256k1PublicKey =
  /*#__PURE__*/
  function () {
    function Secp256k1PublicKey(key) {
      _classCallCheck(this, Secp256k1PublicKey);

      crypto.validatePublicKey(key);
      this._key = key;
    }

    _createClass(Secp256k1PublicKey, [{
      key: "verify",
      value: function verify(data, sig, callback) {
        ensure(callback);
        crypto.hashAndVerify(this._key, sig, data, callback);
      }
    }, {
      key: "marshal",
      value: function marshal() {
        return crypto.compressPublicKey(this._key);
      }
    }, {
      key: "equals",
      value: function equals(key) {
        return this.bytes.equals(key.bytes);
      }
    }, {
      key: "hash",
      value: function hash(callback) {
        ensure(callback);
        multihashing(this.bytes, 'sha2-256', callback);
      }
    }, {
      key: "bytes",
      get: function get() {
        return keysProtobuf.PublicKey.encode({
          Type: keysProtobuf.KeyType.Secp256k1,
          Data: this.marshal()
        });
      }
    }]);

    return Secp256k1PublicKey;
  }();

  var Secp256k1PrivateKey =
  /*#__PURE__*/
  function () {
    function Secp256k1PrivateKey(key, publicKey) {
      _classCallCheck(this, Secp256k1PrivateKey);

      this._key = key;
      this._publicKey = publicKey || crypto.computePublicKey(key);
      crypto.validatePrivateKey(this._key);
      crypto.validatePublicKey(this._publicKey);
    }

    _createClass(Secp256k1PrivateKey, [{
      key: "sign",
      value: function sign(message, callback) {
        ensure(callback);
        crypto.hashAndSign(this._key, message, callback);
      }
    }, {
      key: "marshal",
      value: function marshal() {
        return this._key;
      }
    }, {
      key: "equals",
      value: function equals(key) {
        return this.bytes.equals(key.bytes);
      }
    }, {
      key: "hash",
      value: function hash(callback) {
        ensure(callback);
        multihashing(this.bytes, 'sha2-256', callback);
      }
    }, {
      key: "public",
      get: function get() {
        return new Secp256k1PublicKey(this._publicKey);
      }
    }, {
      key: "bytes",
      get: function get() {
        return keysProtobuf.PrivateKey.encode({
          Type: keysProtobuf.KeyType.Secp256k1,
          Data: this.marshal()
        });
      }
    }]);

    return Secp256k1PrivateKey;
  }();

  function unmarshalSecp256k1PrivateKey(bytes, callback) {
    callback(null, new Secp256k1PrivateKey(bytes), null);
  }

  function unmarshalSecp256k1PublicKey(bytes) {
    return new Secp256k1PublicKey(bytes);
  }

  function generateKeyPair(_bits, callback) {
    if (callback === undefined && typeof _bits === 'function') {
      callback = _bits;
    }

    ensure(callback);
    crypto.generateKey(function (err, privateKeyBytes) {
      if (err) {
        return callback(err);
      }

      var privkey;

      try {
        privkey = new Secp256k1PrivateKey(privateKeyBytes);
      } catch (err) {
        return callback(err);
      }

      callback(null, privkey);
    });
  }

  function ensure(callback) {
    if (typeof callback !== 'function') {
      throw new Error('callback is required');
    }
  }

  return {
    Secp256k1PublicKey: Secp256k1PublicKey,
    Secp256k1PrivateKey: Secp256k1PrivateKey,
    unmarshalSecp256k1PrivateKey: unmarshalSecp256k1PrivateKey,
    unmarshalSecp256k1PublicKey: unmarshalSecp256k1PublicKey,
    generateKeyPair: generateKeyPair
  };
};